module.exports = __webpack_public_path__ + "85fe1fa9002da47827987ff5ec6403c1.pdf";